import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getServicesList } from '../servicesThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'servicesList';

export const servicesListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getServicesList });
    },
});

export const servicesList = servicesListSlice.reducer;
